import { DialogService, GridButton } from '@eforall/dashboard';
import { EventTypeId } from '@interfaces';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';
import { AwardEditorDialog } from '../award-editor-dialog/award-editor.dialog';


export function getButtons(dialogService: DialogService, accAreaService: AcceleratorAreaService): GridButton[] {

	const buttons: GridButton[] = [];

	const graduate: GridButton = {
		iconClass: 'fa-plus',
		label: 'Add Award',
		execute: async () => {

			const data = accAreaService.data();
			if (!data) return;

			// Check if all ventures are graduated or dropped-out before allowing to add awards
			const canAddAward = data.ventures.every(v => v.status !== 'Participating');
			if (!canAddAward) {
				await dialogService.showMessage(`Cannot Add Award`, `All Ventures must be marked as Graduated or Dropped-out to add awards`, 'Okay', [], 300, 200);
				return;
			}

			// check if accelerator awardableDollars is set before allowing to add awards
			if (data.acc.awardableDollars == null) {
				await dialogService.showMessage(`Cannot Add Award`, ` This Accelerator does not have any Award budget assigned, please reach out to Tech to get this updated`, 'Okay', [], 400, 250);
				return;
			}

			// check if showcase event exists before allowing to add awards, as awards are linked to showcase event
			const showCaseEvent = data.events.find(e => e.eventTypeId === EventTypeId.AccShowcase);
			if (!showCaseEvent) {
				await dialogService.showMessage(`Cannot Add Award`, `Showcase event not found for this accelerator`, 'Okay', [], 300, 200);
				return;
			}

			await dialogService.showCustom(AwardEditorDialog, { data: { eventId: showCaseEvent.eventId } }, 600, 700);
			await accAreaService.reloadData();
		}
	};

	if (accAreaService.canEdit()) {
		buttons.push(graduate);
	}

	return buttons;
}